'use strict';

// import 'whatwg-fetch';
// import './lib/polyfills';
import './lib/kit-module';
import './lib/register-module';
import './lib/buttons';
import './lib/nav';
import './lib/scroll-reveal';
import '@lottiefiles/lottie-player';

import kwesforms from 'kwesforms';
kwesforms.init();

